import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locales from 'locales'
import getDefaultBrowserLanguage from './locales/utilities'
import triplaLocalStorage from 'utilities/triplaLocalStorage'

Vue.use(VueI18n)

export default new VueI18n({
  locale: triplaLocalStorage.getItem('triplabot_locale') || getDefaultBrowserLanguage(), // set locale
  fallbackLocale: 'en',
  messages: locales
})
